//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Fields.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/PointList.js";
import "../no/SelectSketch.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/ObjectList.js";
let d=[[[1,"ChordalTolerance",0,"Expression",0],[0,"DiscretePointType",1,1],[0,"Interpolation",1,0],[0,"NumberPoints",1,0],[1,"Offset",0,"Expression",0],[0,"PointSamplingType",1,0],[1,"Points",0,"PointList",0],[1,"Scale",0,"Expression",0],[1,"Sketch",0,"SelectSketch",0],[0,"UnitType",1,"Unit",0]],[[["areMeasuresFixed"],"SetMeasuresFixed",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Fields.SketchProfileBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Fields.SketchProfileBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Fields.SketchProfileBuilder.InterpolationType = Object.freeze({
    "Linear" : "Linear", "Akima" : "Akima", "Akima72" : "Akima72", "Cubic" : "Cubic"});

SPLM.Fields.SketchProfileBuilder.SamplingPointType = Object.freeze({
    "ChordalTolerance" : "ChordalTolerance", "EqualArcLength" : "EqualArcLength"});

export default SPLM;